// Material Dashboard 2 PRO React Examples
import { Currency } from "components/CustomCurrency/currency";
import { Unit } from "components/CustomUnits/units";
import DataTable from "examples/Tables/DataTable";
import PropTypes from "prop-types";

export const CompoundDetailsTable = ({ data }) => {
  let rows = [];
  let total = 0;
  let amount = 0;

  let tableData = {
    columns: [
      { Header: "Empresa", accessor: "Empresa" },
      { Header: "Producto", accessor: "Producto" },
      { Header: "Presentacion", accessor: "Presentacion" },
      { Header: "Ventas ($)", accessor: "Ventas" },
      { Header: "Cantidad", accessor: "Cantidad" },
    ],
    rows: rows,
  };

  if (data.length > 0) {
    data.forEach((element) => {
      total += element.sale;
      amount += element.quantity;
      var _temp = {
        Empresa: element.companyName,
        Producto: element.productName,
        Presentacion: element.presentation,
        Ventas: <Currency value={element.sale} />,
        Cantidad: <Unit value={element.quantity} />,
      };
      rows.push(_temp);
    });
  }

  // Add totales

  rows.push({
    Empresa: "Totales",
    Producto: "",
    Presentacion: "",
    Ventas: <Currency value={total} />,
    Cantidad: <Unit value={amount} />,
  });

  tableData.rows = rows;

  return (
    <DataTable
      canSearch={false}
      entriesPerPage={false}
      showTotalEntries={false}
      table={tableData}
    />
  );
};

CompoundDetailsTable.defaultProps = {
  data: [],
};

CompoundDetailsTable.propTypes = {
  data: PropTypes.array,
};
